import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Brain, Zap, Trophy } from "lucide-react";
import { motion } from "framer-motion";

const BitcoinIQCTA = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card className="p-6 bg-gradient-to-br from-primary/20 via-primary/10 to-background border-primary/30 overflow-hidden relative">
        <div className="absolute top-0 right-0 w-32 h-32 bg-primary/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
        
        <div className="relative z-10 space-y-4">
          <div className="flex items-center gap-2">
            <div className="p-2 rounded-lg bg-primary/20">
              <Brain className="h-5 w-5 text-primary" />
            </div>
            <h3 className="font-bold text-lg">Bitcoin IQ Quiz</h3>
          </div>
          
          <p className="text-sm text-muted-foreground">
            Test your Bitcoin knowledge with 15 challenging questions and discover your true expertise level!
          </p>
          
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <div className="flex items-center gap-1">
              <Zap className="h-3 w-3 text-primary" />
              <span>15 Questions</span>
            </div>
            <div className="flex items-center gap-1">
              <Trophy className="h-3 w-3 text-primary" />
              <span>Earn Title</span>
            </div>
          </div>
          
          <Button asChild size="sm" className="w-full bg-primary hover:bg-primary/90">
            <Link to="/bitcoin-iq">
              Take the Quiz
            </Link>
          </Button>
        </div>
      </Card>
    </motion.div>
  );
};

export default BitcoinIQCTA;
